<div id="resultAmount">
  <span class="text-info">({{ itemCount }} {{ itemCountDescription }})
  </span>
</div>